import { push } from 'modules/gtm/modules/common';

export const gtmPushNewsletterSubscription = () =>
  push({
    event: 'Generic Event',
    event_name: 'newsletter_subscription',
    newsletter_subscription: {
      event_category: 'newsletter',
      event_action: 'subscription',
    },
  });

export const gtmPushNewsletterUnSubscription = () =>
  push({
    event: 'Generic Event',
    event_name: 'newsletter_unsubscription',
    newsletter_unsubscription: {
      event_category: 'newsletter',
      event_action: 'unsubscription',
    },
  });
